import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'
import { PanelCoordinator } from './components/PanelCoordinator'

export let startReaderCourseToC = (coursenum, allowAuthorTools = false) => {
  let drawerKey = `leftDrawerReaderOpen-${coursenum}`
  // whether the drawer should be open on-load
  applyLeftInitialLayout(drawerKey)
  registerCloseLeftDrawerEvent(drawerKey)
  registerOpenLeftDrawerEvent(drawerKey)
  const root = createRoot(document.getElementById('toc-content'))
  root.render(
    <React.Fragment>
      <PanelCoordinator coursenum={coursenum} />
      <App
        coursenum={coursenum}
        drawerKey={drawerKey}
        useLocalStorage={true}
        allowAuthorTools={allowAuthorTools}
      />
    </React.Fragment>
  )
}

export let startOverlayCourseToC = coursenum => {
  let drawerKey = `leftDrawerOpen-${coursenum}`
  // Overlay drawer starts closed; only opened via explicit hover/click events
  const drawer = document.getElementById('left-drawer')
  if (drawer) drawer.setAttribute('inert', '')
  registerCloseLeftDrawerEvent(drawerKey)
  registerOpenLeftDrawerEvent(drawerKey)
  const root = createRoot(document.getElementById('toc-content'))
  root.render(
    <React.Fragment>
      <DrawerBehaviorManager />
      <App
        coursenum={coursenum}
        drawerKey={drawerKey}
        useLocalStorage={false}
      />
    </React.Fragment>
  )
}

function registerCloseLeftDrawerEvent(drawerKey) {
  window.addEventListener('close-left-drawer', () => {
    // Always remove the class — even if already removed
    document.body.classList.remove('has-left-drawer')

    // Drawer is only visually hidden via CSS transform, so it must be
    // marked inert or screen readers can still reach the chapter links
    const drawer = document.getElementById('left-drawer')
    if (drawer) drawer.setAttribute('inert', '')

    const readerLayout = document.getElementById('reader_layout')
    if (readerLayout) readerLayout.style.marginLeft = ''

    const arrow = document.querySelector('.navigation_arrow_left')
    if (arrow) arrow.style.left = ''

    // Only persist state if this drawer uses localStorage
    if (drawerKey.includes('Reader')) {
      try {
        localStorage.setItem(drawerKey, 'false')
      } catch (e) {
        console.error('Non-critical error:', e)
      }
    }
  })
}

function registerOpenLeftDrawerEvent(drawerKey) {
  window.addEventListener('open-left-drawer', () => {
    // Always ensure the class is present
    document.body.classList.add('has-left-drawer')

    // Only persist state if this drawer uses localStorage
    if (drawerKey.includes('Reader')) {
      try {
        localStorage.setItem(drawerKey, 'true')
      } catch (e) {
        console.error('Non-critical error:', e)
      }
    }

    const readerLayout = document.getElementById('reader_layout')
    const drawer = document.getElementById('left-drawer')

    if (drawer) drawer.removeAttribute('inert')

    if (readerLayout && drawer) {
      const drawerWidth = drawer.offsetWidth
      const arrow = document.querySelector('.navigation_arrow_left')
      readerLayout.style.marginLeft = `${drawerWidth}px`
      if (arrow) arrow.style.left = `${drawerWidth + 30}px`
    }
  })
}

function applyLeftInitialLayout(drawerKey) {
  // Add loading class to disable all transitions
  document.body.classList.add('loading')

  // Check if drawer should be open based on localStorage
  try {
    const stored = localStorage.getItem(drawerKey)
    const leftDrawer = document.getElementById('left-drawer')

    if (stored === 'false') {
      if (leftDrawer) leftDrawer.setAttribute('inert', '')
      return
    }

    if (stored === 'true' || stored === null) {
      // Apply drawer open state immediately
      document.body.classList.add('has-left-drawer')

      // Get necessary elements
      const readerLayout = document.getElementById('reader_layout')

      if (leftDrawer) leftDrawer.removeAttribute('inert')

      // Apply layout immediately if elements exist
      if (readerLayout && leftDrawer) {
        const leftDrawerWidth = leftDrawer.offsetWidth
        const arrow = document.querySelector('.navigation_arrow_left')

        // Set correct margins and positions without animation
        readerLayout.style.marginLeft = leftDrawerWidth + 'px'
        if (arrow) arrow.style.left = leftDrawerWidth + 30 + 'px'
      }
    }
  } catch (e) {
    console.error('Non-critical error during initial layout:', e)
  }
}

function DrawerBehaviorManager() {
  useEffect(() => {
    const handleClickOutside = e => {
      const drawer = document.getElementById('left-drawer')
      const navButton = document.getElementById('navMenu')
      const coursesMenuRoot = document.getElementById('courses-menu-root')

      const isLocked = navButton && navButton.dataset.locked === 'true'
      if (!isLocked) return // Only close when locked (not just hovering)
      if (navButton && navButton.contains(e.target)) return
      if (coursesMenuRoot && coursesMenuRoot.contains(e.target)) return // Don't close if clicking in courses menu
      if (drawer && !drawer.contains(e.target)) {
        window.dispatchEvent(new CustomEvent('close-left-drawer'))
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return null
}
